<template>
	<ImageGridShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import ImageGridShell from '../shared/ImageGridShell.vue';
	import { imageBlockEmits, imageBlockProps } from '../shared/imageBlockProps.js';

	export default {
		name: 'GBlockImageGrid',
		components: { ImageGridShell },
		props: imageBlockProps,
		emits: imageBlockEmits,
	};
</script>
